export default __webpack_public_path__ + "static/media/keto_weakness@3x.a0748737.jpg";